import React from 'react';

const SchoolContactCard = ({ schoolContact }) => {
  return (
    <div className="contact-column">
      <p>{schoolContact.name}</p>
      <p>{schoolContact.address.street}</p>
      <p>{schoolContact.address.postalCode} {schoolContact.address.city}</p>
      <p>{schoolContact.address.country}</p>
      <p><strong>Telefon:</strong> {schoolContact.contact.phone}</p>
      <p><strong>Email:</strong> {schoolContact.contact.email}</p>
      <p><strong>IČO:</strong> {schoolContact.contact.ico}</p>
    </div>
  );
};

export default SchoolContactCard; 